<template>
  <div class="box">
    <div class="main-content">
      <!-- 作业信息部分开始 -->
      <div class="paperInformation-box">
        <div class="paperInformation-title">作业信息</div>
        <!-- 作业名称部分开始 -->
        <div class="publicTop-box">
          <div class="flex align justify">
            <div class="flex">
              <div class="requiredIcon">*</div>
              <div class="informationTxt">作业名称:</div>
            </div>
            <div class="main-content-right">
              <div class="publicInput-box">
                <input v-show="editableOrNot" v-model="testPaperName" class="publicInput" type="text"
                  placeholder="请输入作业名称" />
                <input v-show="!editableOrNot" disabled v-model="testPaperName" class="publicInput" type="text"
                  placeholder="请输入作业名称" />
              </div>
            </div>
          </div>
        </div>
        <!-- 作业名称部分结束 -->
        <!-- 所属课次部分开始 -->
        <div class="publicTop-box">
          <div class="flex align justify">
            <div class="flex">
              <div class="requiredIcon">*</div>
              <div class="informationTxt">所属课次:</div>
            </div>
            <div class="main-content-right">
              <van-popover close-on-click-outside placement="bottom-start" v-model="showPopover">
                <div class="selectClass-box">
                  <van-checkbox-group class="checkbox-group" v-for="(item, index) in classList" :key="index"
                    v-model="checked">
                    <van-checkbox shape="square" @click="changeCheckbox(item.name, item.id)" :name="item.name">课次 {{
                  index + 1 }} {{ item.name }}</van-checkbox>
                  </van-checkbox-group>
                </div>
                <template #reference>
                  <div v-show="editableOrNot" @click="showPopover = true"
                    class="publicInput-box flex align spaceBetween">
                    <input v-model="checked" disabled class="publicInput" type="text" placeholder="请选择所属课次" />
                    <img @click="showPopover = true" style="margin-right: 17px"
                      src="../../assets/courseInformation/add.png" />
                  </div>
                  <div v-show="!editableOrNot" class="publicInput-box flex align spaceBetween">
                    <input v-model="checked" disabled class="publicInput" type="text" placeholder="请选择所属课次" />
                    <img style="margin-right: 17px" src="../../assets/courseInformation/add.png" />
                  </div>
                </template>
              </van-popover>
            </div>
          </div>
        </div>
        <!-- 所属课次部分结束 -->
        <!-- 资源用途部分开始 -->
        <div class="publicTop-box">
          <div class="flex align justify">
            <div class="flex">
              <div class="requiredIcon">*</div>
              <div class="informationTxt">资源用途:</div>
            </div>
            <div class="main-content-right">
              <div v-show="editableOrNot" class="useResources-box flex spaceBetween">
                <div @click="useResources = 'front'" class="flex align pointer">
                  <div :class="this.useResources == 'front' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                  <div :class="this.useResources == 'front' ? 'selectUseTxt' : 'unSelectUseTxt'">课前</div>
                </div>
                <div @click="useResources = 'middle'" class="flex align pointer">
                  <div :class="this.useResources == 'middle' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                  <div :class="this.useResources == 'middle' ? 'selectUseTxt' : 'unSelectUseTxt'">课中</div>
                </div>
                <div @click="useResources = 'back'" class="flex align pointer">
                  <div :class="this.useResources == 'back' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                  <div :class="this.useResources == 'back' ? 'selectUseTxt' : 'unSelectUseTxt'">课后</div>
                </div>
              </div>
              <div v-show="!editableOrNot" class="useResources-box flex spaceBetween">
                <div class="flex align pointer" style="cursor: not-allowed">
                  <div :class="this.useResources == 'front' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                  <div :class="this.useResources == 'front' ? 'selectUseTxt' : 'unSelectUseTxt'">课前</div>
                </div>
                <div class="flex align pointer" style="cursor: not-allowed">
                  <div :class="this.useResources == 'middle' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                  <div :class="this.useResources == 'middle' ? 'selectUseTxt' : 'unSelectUseTxt'">课中</div>
                </div>
                <div class="flex align pointer" style="cursor: not-allowed">
                  <div :class="this.useResources == 'back' ? 'selectUseCircle' : 'unSelectUseCircle'"></div>
                  <div :class="this.useResources == 'back' ? 'selectUseTxt' : 'unSelectUseTxt'">课后</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 资源用途部分结束 -->
      </div>
      <!-- 作业信息部分结束 -->
      <!-- 作业内容部分开始 -->
      <div class="paperContent-box">
        <!-- 手动选题部分开始 -->
        <div v-if="this.fromWhere == 'handMovement'">
          <div class="paperContentBox flex spaceBetween">
            <div class="paperContent-title">作业内容</div>
            <div class="addTopic-box flex align spaceBetween">
              <img v-show="editableOrNot" @click="addTopic" class="addTopic pointer" src="../../assets/addTopic.png" />
              <img v-show="editableOrNot" @click="addFromProblemLibrary" class="addFromProblemLibrary pointer"
                src="../../assets/addFromProblemLibrary.png" />
            </div>
          </div>
          <div class="gather-box flex">
            <div class="flex align">
              <div class="gather-txt">总题数:</div>
              <div class="gather-num">{{ questionBankList.length }}</div>
            </div>
            <div class="flex align" style="margin-left: 33px">
              <div class="gather-txt">总分:</div>
              <div class="gather-num">{{ totalPoints }}</div>
            </div>
          </div>
          <!-- 未添加题目 -->
          <div class="notAdded" v-if="questionBankList == []">未添加题目</div>
          <!-- 习题列表部分开始 -->
          <template v-if="questionBankList != []">
            <div class="exampleList" v-for="(item, index) in questionBankList" :key="index">
              <!-- 题干 -->
              <div class="flex align spaceBetween">
                <div class="flex align">
                  <div class="topicType">{{ item.types }}</div>
                  <div class="questionNo">{{ index + 1 }}.</div>
                  <div class="stem">{{ item.content }}</div>
                </div>
                <div class="flex align">
                  <div class="score-txt">分值:</div>
                  <div class="score-inputFrame flex justify">
                    <input v-show="editableOrNot" v-model="item.inputValue" class="score-input" type="text" />
                    <input v-show="!editableOrNot" disabled v-model="item.inputValue" class="score-input" type="text" />
                  </div>
                  <div v-show="editableOrNot" @click="modifyScore(item)"
                    class="score-modify flex align justify pointer">修改分数</div>
                  <div v-show="editableOrNot" @click="modifyItem(item)" class="score-modify flex align justify pointer">
                    修改试题</div>
                  <img v-show="editableOrNot" @click="btnDelete(index)" class="btnDelete pointer"
                    src="../../assets/resourceManagement/btnDelete.png" />
                </div>
              </div>
              <!-- 选项 -->
              <div v-if="item.types == '单选题' || item.types == '多选题' || item.types == '判断题'" class="exampleList-option">
                <div v-for="(item, index) in item.options" :key="index">
                  <div class="exampleList-option-txt">{{ optionOrder[index] }}.{{ item }}</div>
                </div>
              </div>
              <!-- 答案 -->
              <div v-if="item.types == '单选题' || item.types == '多选题' || item.types == '判断题'" class="answer flex align">
                <div class="answer-txt">答案:</div>
                <div class="answer-English">{{ item.answer1.toString().replaceAll(",", "、") }}</div>
              </div>
              <div v-if="item.types == '填空题'" class="answer flex align">
                <div class="answer-txt">答案:</div>
                <div class="blankAnswer" v-for="(items, index) in item.options" :key="index">第{{ index + 1 }}空: {{ items
                  }}
                </div>
              </div>
              <div v-if="item.types == '填空题'" class="answer flex align">
                <div v-if="index < item.options.length" class="flex align" v-for="(items, index) in item.scoreList"
                  :key="index">
                  <div class="blankAnswer">第{{ index + 1 }}空分值:</div>
                  <div class="score-inputFrame flex justify">
                    <input v-show="editableOrNot" v-model="items.text" class="score-input" type="text" />
                    <input v-show="!editableOrNot" disabled v-model="items.text" class="score-input" type="text" />
                  </div>
                </div>
              </div>
              <!-- 解析 -->
              <div class="answer flex">
                <div class="answer-txt">解析:</div>
                <div class="answer-English">{{ item.comment }}</div>
              </div>
            </div>
          </template>
          <!-- 习题列表部分结束 -->
        </div>
        <!-- 手动选题部分结束 -->
        <!-- 自动选题部分开始 -->
        <div v-if="this.fromWhere == 'voluntarily'">
          <div class="paperContentBox flex spaceBetween">
            <div class="paperContent-title">作业内容</div>
          </div>
          <div class="gather-box flex">
            <div class="flex align">
              <div class="gather-txt">总题数:</div>
              <div class="gather-num">0</div>
            </div>
            <div class="flex align" style="margin-left: 33px">
              <div class="gather-txt">总分:</div>
              <div class="gather-num">0</div>
            </div>
          </div>
          <!-- 出题范围部分开始 -->
          <div class="questionScope-box">
            <div class="flex align justify">
              <div class="flex">
                <div class="requiredIcon">*</div>
                <div class="informationTxt">出题范围:</div>
              </div>
              <div class="main-content-right">
                <van-popover close-on-click-outside placement="bottom-start" v-model="showPopover1">
                  <div class="selectClass-box">
                    <van-checkbox-group class="checkbox-group" v-for="(item, index) in classList" :key="index"
                      v-model="checked1">
                      <van-checkbox shape="square" @click="changeCheckbox1(item.name, item.id)" :name="item.name">课次 {{
                  index
                  + 1 }} {{ item.name }}</van-checkbox>
                    </van-checkbox-group>
                  </div>
                  <template #reference>
                    <div @click="showPopover1 = true" class="publicInput-box flex align spaceBetween">
                      <input v-model="checked1" disabled class="publicInput" type="text" placeholder="请选择出题范围" />
                      <img @click="showPopover1 = true" style="margin-right: 17px"
                        src="../../assets/courseInformation/add.png" />
                    </div>
                  </template>
                </van-popover>
              </div>
            </div>
          </div>
          <!-- 出题范围部分结束 -->
          <!-- 题目类型部分开始 -->
          <div class="questionScope-box flex justify">
            <div class="publicTop flex">
              <div class="requiredIcon">*</div>
              <div class="informationTxt">题目类型:</div>
            </div>
            <div style="margin-left: 33px">
              <!-- 单选题 -->
              <div>
                <div class="type-box">单选题</div>
                <div class="questionScope-box flex spaceBetween">
                  <div class="publicTop flex">
                    <div class="requiredIcon">*</div>
                    <div class="informationTxt">题目数量:</div>
                  </div>
                  <div class="flex">
                    <div class="typeInputBox flex align">
                      <input class="typeInput" type="text" v-model="singleNum" placeholder="请输入题目数量" />
                    </div>
                  </div>
                </div>
                <div class="questionScope-box flex spaceBetween">
                  <div class="publicTop flex">
                    <div class="requiredIcon">*</div>
                    <div class="informationTxt">每题分值:</div>
                  </div>
                  <div class="flex">
                    <div class="typeInputBox flex align">
                      <input class="typeInput" type="text" v-model="singleScore" placeholder="请输入每道小题的分值" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- 多选题 -->
              <div class="questionScope-box">
                <div class="type-box">多选题</div>
                <div class="questionScope-box flex spaceBetween">
                  <div class="publicTop flex">
                    <div class="requiredIcon">*</div>
                    <div class="informationTxt">题目数量:</div>
                  </div>
                  <div class="flex">
                    <div class="typeInputBox flex align">
                      <input class="typeInput" type="text" v-model="multipleNum" placeholder="请输入题目数量" />
                    </div>
                  </div>
                </div>
                <div class="questionScope-box flex spaceBetween">
                  <div class="publicTop flex">
                    <div class="requiredIcon">*</div>
                    <div class="informationTxt">每题分值:</div>
                  </div>
                  <div class="flex">
                    <div class="typeInputBox flex align">
                      <input class="typeInput" type="text" v-model="multipleScore" placeholder="请输入每道小题的分值" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- 判断题 -->
              <div class="questionScope-box">
                <div class="type-box">判断题</div>
                <div class="questionScope-box flex spaceBetween">
                  <div class="publicTop flex">
                    <div class="requiredIcon">*</div>
                    <div class="informationTxt">题目数量:</div>
                  </div>
                  <div class="flex">
                    <div class="typeInputBox flex align">
                      <input class="typeInput" type="text" v-model="trueFalseNum" placeholder="请输入题目数量" />
                    </div>
                  </div>
                </div>
                <div class="questionScope-box flex spaceBetween">
                  <div class="publicTop flex">
                    <div class="requiredIcon">*</div>
                    <div class="informationTxt">每题分值:</div>
                  </div>
                  <div class="flex">
                    <div class="typeInputBox flex align">
                      <input class="typeInput" type="text" v-model="trueFalseScore" placeholder="请输入每道小题的分值" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- 简答题 -->
              <div class="questionScope-box">
                <div class="type-box">简答题</div>
                <div class="questionScope-box flex spaceBetween">
                  <div class="publicTop flex">
                    <div class="requiredIcon">*</div>
                    <div class="informationTxt">题目数量:</div>
                  </div>
                  <div class="flex">
                    <div class="typeInputBox flex align">
                      <input class="typeInput" type="text" v-model="answerNum" placeholder="请输入题目数量" />
                    </div>
                  </div>
                </div>
                <div class="questionScope-box flex spaceBetween">
                  <div class="publicTop flex">
                    <div class="requiredIcon">*</div>
                    <div class="informationTxt">每题分值:</div>
                  </div>
                  <div class="flex">
                    <div class="typeInputBox flex align">
                      <input class="typeInput" type="text" v-model="answerScore" placeholder="请输入每道小题的分值" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 题目类型部分结束 -->
        </div>
        <!-- 自动选题部分结束 -->
      </div>
      <!-- 手动按钮 -->
      <div v-if="this.fromWhere == 'handMovement' && editableOrNot" class="btnTestpaperBox flex spaceBetween">
        <div @click="btnUploadTestpaper" class="pushButton pointer">上传作业</div>
        <div @click="btnCancel" class="pushButton pointer">取消</div>
      </div>
      <div v-if="this.fromWhere == 'handMovement' && !editableOrNot" class="btnTestpaperBox flex justify">
        <div @click="btnCancel" class="pushButton pointer">返回</div>
      </div>
      <!-- 自动按钮 -->
      <div v-if="this.fromWhere == 'voluntarily' && editableOrNot" class="btnTestpaperBox flex justify spaceBetween">
        <div @click="createTestpaper" class="pushButton pointer">生成作业</div>
        <div @click="btnCancel" class="pushButton pointer">取消</div>
      </div>
      <div v-if="this.fromWhere == 'voluntarily' && !editableOrNot" class="btnTestpaperBox flex justify">
        <div @click="btnCancel" class="pushButton pointer">返回</div>
      </div>
      <!-- 作业内容部分结束 -->
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { testPaperAddition, testPaperModification, autoGenerate, testPaperDetails, deleteTestQuestions, testPaperAddClass, testPaperDelClass, testPaperModifyTestScores, batchAddTestQuestions } from "@/api";
export default {
  data() {
    return {
      editableOrNot: true, // 是否可编辑
      identity: "", // 登录身份
      checked: [], // 所属课次
      checked1: [], // 自动选题=>出题范围
      testPaperName: "", // 作业名称
      useResources: "", // 选中的资源用途
      classList: [], // 课次列表
      singleNum: "", // 自动选题=>单选题数量
      singleScore: "", // 自动选题=>单选题总分
      multipleNum: "", // 自动选题=>多选题数量
      multipleScore: "", // 自动选题=>多选题总分
      trueFalseNum: "", // 自动选题=>判断题数量
      trueFalseScore: "", // 自动选题=>判断题总分
      answerNum: "", // 自动选题=>简答题数量
      answerScore: "", // 自动选题=>简答题总分
      showPopover: false,
      showPopover1: false,
      fromWhere: "", // 是手动还是自动组卷
      isTypes: false, // 自动
      questionBankList: [], // 题目库列表
      classesList: [], // 所属课次列表
      classesList1: [], // 出题范围
      totalPoints: 0, // 题目总分
      exampleID: "", // 习题ID
      examId: null, // 作业id
      exampleScore: "", // 习题分值
      optionOrder: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
    };
  },
  created() {
    this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态

    if (this.$route.params.whetherModified) {
      if (this.$route.params.whetherModified == "no") {
        this.editableOrNot = false;
      }
    }
    if (this.$route.params.emptyOrNot) {
      this.$store.state.questionBankData = []; // 从作业库页面过来清空数据
    }
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    this.fromWhere = this.$route.params.method;
    // this.fromWhere = "handMovement";
    if (this.cookie.get("ExamId")) {
      this.examId = this.cookie.get("ExamId");
      this.cookie.remove("ExamId");
    }
    this.classList = this.$store.state.classListRecord; // 获取课次列表
    // 作业修改进入获取内容
    if (this.$route.params.record) {
      this.examId = this.$route.params.record; // 获取修改的作业id
      // 调用作业详情接口
      let params = { id: this.examId };
      testPaperDetails(params).then((res) => {
        // 获取作业名称
        this.testPaperName = res.data.datas.name;
        // 获取作业所属用途
        this.useResources = res.data.datas.usage;
        // 获取作业所属课次
        for (let i = 0; i < res.data.datas.lesson_items.length; i++) {
          this.checked.push(res.data.datas.lesson_items[i].name);
        }
        // 获取试题列表
        let publicRes = res.data.datas.exam_items;
        for (let i = 0; i < publicRes.length; i++) {
          publicRes[i].exam_item.linkScore = publicRes[i].score; // 获取试题的link分数
          publicRes[i].exam_item.inputValue = publicRes[i].exam_item.linkScore;
          publicRes[i].exam_item.examId = publicRes[i].exam_id; // 获取作业id
          publicRes[i].exam_item.examItemId = publicRes[i].exam_item_id; // 获取试题id
          if (publicRes[i].exam_item.types == "blank") {
            publicRes[i].exam_item.scores = publicRes[i].scores; // 获取link
            console.log(publicRes[i]);
          }
          this.questionBankList.push(publicRes[i].exam_item);
        }
        if (this.$store.state.questionBankData.length != 0) {
          this.$store.state.questionBankData.forEach((publicRes) => {
            // 提取分数并转换为数字
            const scoreValue = parseFloat(publicRes.score.replace(/分/g, ""));
            // 更新对象属性
            publicRes.linkScore = scoreValue;
            publicRes.inputValue = scoreValue;
          });
          // 获取题目列表
          this.questionBankList = this.questionBankList.concat(this.$store.state.questionBankData);
        }
        if (this.$route.params.topicData) {
          // 提取分数并转换为数字
          const scoreValue = parseFloat(this.$route.params.topicData.score.replace(/分/g, ""));
          // 更新对象属性
          this.$route.params.topicData.linkScore = scoreValue;
          this.$route.params.topicData.inputValue = scoreValue;
          this.questionBankList.push(this.$route.params.topicData); // 从添加题目页面获取的数据
        }
        // 数据转换:获取的数据
        for (let i = 0; i < this.questionBankList.length; i++) {
          if (this.questionBankList[i].types == "blank" || this.questionBankList[i].types == "填空题") {
            this.questionBankList[i].scoreList = this.questionBankList[i].scores?.map((item) => {
              return { text: item };
            });
            console.log(this.questionBankList[i]);
          }
          this.totalPoints += this.questionBankList[i].linkScore; // 题目总分计算
          this.questionBankList[i].answer1 = [];
          for (let j = 0; j < this.questionBankList[i].answer.length; j++) {
            this.questionBankList[i].answer1[j] = this.optionOrder[this.questionBankList[i].answer[j]]; // 题目答案获取
          }
          this.questionBankList[i].content = this.questionBankList[i].content.replace(/<[^>]+>/g, ""); // 题目题干获取
          this.questionBankList[i].comment = this.questionBankList[i].comment.replace(/<[^>]+>/g, ""); // 题目解析获取
          if (this.questionBankList[i].types == "判断题") {
            this.questionBankList[i].options[0] = "正确";
            this.questionBankList[i].options[1] = "错误";
          }
          if (this.questionBankList[i].types == "single") {
            this.questionBankList[i].types = "单选题";
          } else if (this.questionBankList[i].types == "multi") {
            this.questionBankList[i].types = "多选题";
          } else if (this.questionBankList[i].types == "truefalse") {
            this.questionBankList[i].types = "判断题";
            this.questionBankList[i].options[0] = "正确";
            this.questionBankList[i].options[1] = "错误";
          } else if (this.questionBankList[i].types == "answer") {
            this.questionBankList[i].types = "简答题";
          } else if (this.questionBankList[i].types == "blank") {
            this.questionBankList[i].types = "填空题";
          }
        }
      });
    } else {
      if (this.$store.state.questionBankData.length != 0) {
        this.questionBankList = this.$store.state.questionBankData
        this.testPaperName = this.$store.state.testPaperNameData;
      }
      if (this.$route.params.topicData) this.questionBankList.push(this.$route.params.topicData); // 从添加题目页面获取的数据
      for (let i = 0; i < this.questionBankList.length; i++) {
        if (this.questionBankList[i].types == "blank" || this.questionBankList[i].types == "填空题") {
          this.questionBankList[i].scoreList = this.questionBankList[i].scores.map((item) => {
            return { text: item };
          });
        }
        this.questionBankList[i].content = this.questionBankList[i].content.replace(/<[^>]+>/g, ""); // 题目题干获取
        this.questionBankList[i].comment = this.questionBankList[i].comment.replace(/<[^>]+>/g, ""); // 题目解析获取
        this.questionBankList[i].score = this.questionBankList[i].score.replace("分", ""); // 题目分值获取
        this.questionBankList[i].inputValue = this.questionBankList[i].score.replace("分", ""); // 题目分值获取
        this.totalPoints += parseFloat(this.questionBankList[i].score.replace("分", "")); // 题目总分计算
        this.questionBankList[i].answer1 = this.questionBankList[i].answer;
        for (let j = 0; j < this.questionBankList[i].answer1.length; j++) {
          if (!isNaN(this.questionBankList[i].answer1[j])) {
            this.questionBankList[i].answer1[j] = this.optionOrder[this.questionBankList[i].answer1[j]]; // 题目答案获取
          }
        }
        if (this.questionBankList[i].types == "判断题") {
          this.questionBankList[i].options[0] = "正确";
          this.questionBankList[i].options[1] = "错误";
        }
        if (this.questionBankList[i].types == "single") {
          this.questionBankList[i].types = "单选题";
        } else if (this.questionBankList[i].types == "multi") {
          this.questionBankList[i].types = "多选题";
        } else if (this.questionBankList[i].types == "truefalse") {
          this.questionBankList[i].types = "判断题";
          this.questionBankList[i].options[0] = "正确";
          this.questionBankList[i].options[1] = "错误";
        } else if (this.questionBankList[i].types == "answer") {
          this.questionBankList[i].types = "简答题";
        } else if (this.questionBankList[i].types == "blank") {
          this.questionBankList[i].types = "填空题";
        }
      }
    }
  },
  methods: {
    // 更改习题所属课次
    changeCheckbox(classIdx, idx) {
      if (this.classesList.indexOf(idx) > -1) {
        this.classesList.splice(this.classesList.indexOf(idx), 1);
      } else {
        this.classesList.push(idx);
      }
      console.log(this.checked);
      this.$store.commit("GET_testPaperClassNumData", this.checked); // 储存作业课次
      console.log(this.classesList);
      if (this.examId) {
        if (this.checked.indexOf(classIdx) === -1) {
          // 删除习题课次关联
          let data = { exam_id: this.examId, lession_item_id: idx };
          testPaperDelClass(data).then((res) => { });
        } else {
          // 添加习题课次关联
          let data = { exam_id: this.examId, lession_item_id: idx, lession_id: this.$store.state.courseDetails.id };
          testPaperAddClass(data).then((res) => { });
        }
      }
    },
    // 出题范围
    changeCheckbox1(classIdx, idx) {
      if (this.classesList1.indexOf(idx) > -1) {
        this.classesList1.splice(this.classesList1.indexOf(idx), 1);
      } else {
        this.classesList1.push(idx);
      }
    },
    // 添加题目
    addTopic() {
      this.$router.push({
        name: "addExercises",
        params: { comeFrom: "addTopic", examId: this.examId },
      });
      this.$store.commit("GET_testPaperNameData", this.testPaperName); // 储存作业名称
    },
    // 删除题目
    btnDelete(idx) {
      // console.log(idx);
      // console.log(this.questionBankList[idx]);
      if (this.examId) {
        // 修改作业时从数据库删除试题
        let data = { exam_id: this.examId, exam_item_id: this.questionBankList[idx].id };
        deleteTestQuestions(data).then((res) => {
          this.totalPoints -= this.questionBankList[idx].score;
          this.questionBankList.splice(idx, 1);
        });
      } else {
        // 手动选题时从试题列表删除试题
        this.totalPoints -= this.questionBankList[idx].score.replace("分", "");
        this.questionBankList.splice(idx, 1);
        this.$store.commit("GET_questionBankData", this.questionBankList); // 储存题目列表到store
      }
    },
    // 修改作业习题分数
    modifyScore(questionsData) {
      console.log(questionsData);
      // 调用作业试题修改接口
      let data = { exam_id: questionsData.examId, exam_item_id: questionsData.examItemId, score: questionsData.inputValue };
      testPaperModifyTestScores(data).then((res) => {
        if (res.data.code == 0) {
          Toast("修改成功！");
        }
      });
    },
    // 修改习题
    modifyItem(questionsData) {
      console.log(questionsData);
      this.$router.push({
        name: "addExercises",
        params: { record: questionsData, examId: this.examId },
      });
    },
    // 从习题库添加
    addFromProblemLibrary() {
      if (this.examId) {
        // 修改
        this.$router.push({
          name: "addFromProblemLibrary",
          params: { record: this.examId },
        });
      } else {
        this.$router.push("/addFromProblemLibrary");
        this.$store.commit("GET_testPaperNameData", this.testPaperName); // 储存作业名称
      }
    },
    // 上传作业按钮
    btnUploadTestpaper() {
      // console.log("作业名称:", this.testPaperName);
      // console.log("所属课次:", this.checked);
      // console.log("试题列表:", this.questionBankList);
      let score = 0;
      for (let i in this.questionBankList) {
        score += Number(this.questionBankList[i].inputValue);
      }
      // 手动选题
      if (this.testPaperName == "") {
        Toast("请输入作业名称！");
      } else if (this.checked.length == 0) {
        Toast("请选择所属课次！");
      } else if (this.useResources == "") {
        Toast("请选择资源用途！");
      } else if (this.questionBankList.length == 0) {
        Toast("请添加题目！");
      } else {
        for (let i = 0; i < this.questionBankList.length; i++) {
          this.exampleID += this.questionBankList[i].id + ",";
          this.exampleScore += this.questionBankList[i].inputValue + ",";
        }
        if (!this.examId) {
          // 所选课次数据
          let total1 = "";
          for (let i = 0; i < this.classesList.length; i++) {
            total1 += this.classesList[i] + ",";
          }
          console.log(this.classesList);
          let type = "";
          if (this.isTypes) {
            type = "auto";
          } else {
            type = "manual";
          }
          let data = {
            score: score,
            lesson_item_ids: total1,
            name: this.testPaperName,
            types: type,
            exam_item_ids: this.exampleID,
            exam_item_scores: this.exampleScore,
            lesson_id: this.$store.state.courseDetails.id,
            usage: this.useResources,
          };
          testPaperAddition(data).then((res) => {
            if (res.data.code == 0) {
              Toast("上传成功！");
              this.$router.push("/resourceManagement");
            }
          });
        } else {
          // 调用作业修改接口
          let data = {
            score: score,
            name: this.testPaperName,
            id: this.examId,
            usage: this.useResources,
          };
          testPaperModification(data).then((res) => {
            if (res.data.code == 0) {
              // 调用作业批量添加试题接口
              let data = {
                exam_id: this.examId,
                exam_item_ids: this.exampleID,
                scores: this.exampleScore,
              };
              batchAddTestQuestions(data).then((res) => {
                this.$router.push("/resourceManagement");
                Toast("修改成功！");
              });
            }
          });
        }
      }
    },
    // 生成作业
    createTestpaper() {
      let verify = {
        testPaperName: { key: this.testPaperName, not: "", tip: "请输入作业名称！" },
        checked: { key: this.checked.length, not: 0, tip: "请选择所属课次！" },
        checked1: { key: this.checked1.length, not: 0, tip: "请选择出题范围！" },
      };
      for (let item in verify) {
        let { key, not, tip } = verify[item];
        if (key == not) {
          Toast(tip);
          return;
        }
      }
      // 所选课次数据
      let total1 = "";
      for (let i = 0; i < this.classesList.length; i++) {
        total1 += this.classesList[i] + ",";
      }
      // 出题范围
      let total2 = "";
      for (let i = 0; i < this.classesList1.length; i++) {
        total2 += this.classesList1[i] + ",";
      }
      let data = {
        lesson_item_ids: total2,
        num_single: this.singleNum,
        num_multi: this.multipleNum,
        num_truefalse: this.trueFalseNum,
        num_answer: this.answerNum,
      };
      autoGenerate(data).then((res) => {
        if (res.data.code == 0) {
          Toast("上传成功！");
          // this.$router.push({ name: "addTestPaper", method: "handMovement" });
          console.log(res.data.datas);
          this.questionBankList = res.data.datas;
          this.fromWhere = "handMovement";
          this.isTypes = true;
          console.log(this.questionBankList);
          for (let i = 0; i < this.questionBankList.length; i++) {
            this.questionBankList[i].content = this.questionBankList[i].content.replace(/<[^>]+>/g, ""); // 题目题干获取
            this.questionBankList[i].comment = this.questionBankList[i].comment.replace(/<[^>]+>/g, ""); // 题目解析获取
            this.questionBankList[i].score = this.questionBankList[i].score; // 题目分值获取
            this.totalPoints += parseFloat(this.questionBankList[i].score); // 题目总分计算
            this.questionBankList[i].answer1 = this.questionBankList[i].answer;
            for (let j = 0; j < this.questionBankList[i].answer1.length; j++) {
              this.questionBankList[i].answer1[j] = this.optionOrder[this.questionBankList[i].answer1[j]]; // 题目答案获取
            }
            if (this.questionBankList[i].types == "判断题") {
              this.questionBankList[i].options[0] = "正确";
              this.questionBankList[i].options[1] = "错误";
            }
            if (this.questionBankList[i].types == "single") {
              this.questionBankList[i].types = "单选题";
              this.questionBankList[i].inputValue = this.singleScore;
            } else if (this.questionBankList[i].types == "multi") {
              this.questionBankList[i].types = "多选题";
              this.questionBankList[i].inputValue = this.multipleScore;
            } else if (this.questionBankList[i].types == "truefalse") {
              this.questionBankList[i].types = "判断题";
              this.questionBankList[i].options[0] = "正确";
              this.questionBankList[i].options[1] = "错误";
              this.questionBankList[i].inputValue = this.trueFalseScore;
            } else if (this.questionBankList[i].types == "answer") {
              this.questionBankList[i].types = "简答题";
              this.questionBankList[i].inputValue = this.answerScore;
            }
          }
        }
      });
    },
    // 取消按钮
    btnCancel() {
      this.$router.push("/resourceManagement");
    },
  },
};
</script>

<style lang="scss" scoped>
.selectUseTxt {
  margin-left: 6px;
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
}

.unSelectUseTxt {
  margin-left: 6px;
  font-size: 20px;

  font-weight: 400;
  color: #b9b9b9;
}

.pointer {
  cursor: pointer;
}

::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}

.box {
  width: 100%;
  height: 100%;
  display: flex;
}

.main-content {
  width: 1740px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

// 作业信息部分
.paperInformation-box {
  width: 1740px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
}

.paperInformation-title {
  margin-top: 30px;
  margin-left: 30px;
  font-size: 22px;

  font-weight: 400;
  color: #349afe;
}

.main-content-right {
  width: 1482px;
  margin-left: 33px;
}

.informationTxt {
  font-size: 22px;

  font-weight: 400;
  color: #555555;
}

.requiredIcon {
  width: 10px;
  height: 10px;
  color: #ff0000;
}

// 公共输入框样式
.publicInput-box {
  width: 1482px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
}

.publicInput {
  font-size: 20px;

  font-weight: 400;
  color: #555555;
  margin-left: 17px;
  width: 1100px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

// 选择班级组件
.selectClass-box {
  width: 1482px;
  max-height: 300px;
  padding: 0px 20px 20px 20px;
  box-sizing: border-box;
  overflow: scroll;
}

// 作业内容部分
.paperContent-box {
  position: relative;
  margin-top: 20px;
  width: 1740px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  box-sizing: border-box;
  overflow: scroll;
  padding-bottom: 30px;
}

.paperContent-title {
  font-size: 22px;

  font-weight: 400;
  color: #349afe;
}

.gather-txt {
  font-size: 18px;

  font-weight: 400;
  color: #555555;
}

.gather-num {
  margin-left: 12px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

// 习题列表
.exampleList {
  padding: 20px 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.topicType {
  width: 80px;
  height: 25px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background: #b3cae2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.questionNo {
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 12px;
}

.stem {
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 12px;
}

.exampleList-option {
  margin-top: 15px;
  margin-left: 85px;
  border-left: 4px solid #dddddd;
  padding-left: 15px;
}

.exampleList-option-txt {
  font-size: 14px;

  font-weight: 400;
  color: #000000;
  line-height: 23px;
}

.answer-txt {
  width: 47px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.answer-English {
  margin-left: 12px;
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
}

.score-inputFrame {
  margin-left: 9px;
  width: 50px;
  height: 24px;
  border: 1px solid #757575;
  border-radius: 5px;
}

.score-input {
  font-size: 18px;

  font-weight: 400;
  color: #349afe;
  width: 50px;
  height: 24px;
  border: 1px solid #757575;
  border-radius: 10px;
  text-align: center;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.score-txt {
  font-size: 18px;

  font-weight: 400;
  color: #555555;
}

.pushButton {
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}

.notAdded {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 72px;

  font-weight: 400;
  color: #555555;
  opacity: 0.5;
}

.type-box {
  padding: 0px 18px;
  width: 1482px;
  height: 50px;
  background: #dcecfb;
  border-radius: 10px;
  font-size: 22px;

  font-weight: 400;
  color: #555555;
  line-height: 50px;
  align-items: center;
  box-sizing: border-box;
}

.typeInputBox {
  padding-left: 19px;
  margin-left: 33px;
  width: 1324px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
}

.typeInput {
  font-size: 22px;

  font-weight: 400;
  color: #349afe;
  width: 500px;
  height: 50px;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.selectUseCircle {
  width: 12px;
  height: 12px;
  background: #349afe;
  border-radius: 50%;
}

.unSelectUseCircle {
  width: 8px;
  height: 8px;
  border: 2px solid #b8b8b8;
  border-radius: 50%;
}

.addTopic {
  width: 106px;
  height: 18px;
}

.addFromProblemLibrary {
  width: 147px;
  height: 19px;
}

.publicTop-box {
  margin-top: 16px;
}

.publicTop-box:last-child {
  margin-top: 16px;
  margin-bottom: 30px;
}

.checkbox-group {
  margin-top: 20px;
}

.useResources-box {
  width: 262px;
}

.paperContentBox {
  padding: 30px 30px 20px 30px;
  box-sizing: border-box;
}

.addTopic-box {
  width: 284px;
}

.gather-box {
  margin-left: 30px;
}

.btnDelete {
  margin-left: 20px;
  width: 68px;
  height: 20px;
}

.answer {
  margin-left: 85px;
  margin-top: 16px;
}

.questionScope-box {
  margin-top: 20px;
}

.publicTop {
  margin-top: 12px;
}

.btnTestpaperBox {
  width: 410px;
  margin-top: 30px;
}

.score-modify {
  margin-left: 9px;
  width: 80px;
  height: 26px;
  background: #349afe;
  border-radius: 5px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
}
</style>
